/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.382 3A.382.382 0 003 3.382C3 10.903 9.097 17 16.618 17a.382.382 0 00.382-.382v-4.074l-3.702-1.48-1.104 1.84a.5.5 0 01-.65.191 10.206 10.206 0 01-4.64-4.639.5.5 0 01.192-.65l1.84-1.104L7.456 3H3.382zM2 3.382C2 2.62 2.619 2 3.382 2h4.412a.5.5 0 01.464.314l1.765 4.412a.5.5 0 01-.207.615L8.015 8.42a9.206 9.206 0 003.564 3.564l1.08-1.801a.5.5 0 01.615-.207l4.412 1.765a.5.5 0 01.314.464v4.412C18 17.38 17.381 18 16.618 18 8.545 18 2 11.456 2 3.382z" _fill="#1F222C"/>'
  }
})
